import React from 'react';
import { Link } from 'react-router-dom';

// Iter 937 (Kamel) — « Choisissez votre date » : les DÉPARTS réels d'une page commune (trip.departs, calculés côté serveur depuis les
// déclinaisons d'inscription). Blocs empilés lisibles sur téléphone ; chaque départ ouvre le formulaire avec SA déclinaison présélectionnée.
// Iter 938 — les dates déjà passées ne sont plus proposées (trip.departs_passes) ; places restantes = compteur existant de la déclinaison.
const STATUT = {
  disponible: ['PLACES DISPONIBLES', 'bg-green-200 text-green-800'],
  moins_10: ['DERNIÈRES PLACES', 'bg-amber-200 text-amber-900'],
  complet: ['COMPLET', 'bg-red-100 text-red-600'],
  liste_attente: ["LISTE D'ATTENTE", 'bg-orange-100 text-orange-600'],
};

export const titreDeparts = (trip) => {
  const n = (trip.departs || []).length;
  if (!trip.multi_departs || !n) return '';
  const jour = (trip.duration_days || 1) <= 1;
  if (n === 1) return `Dernier${jour ? 'e date' : ' séjour'} proposé${jour ? 'e' : ''}`;
  return `${n} ${jour ? 'dates' : 'séjours'} au choix`;
};

export const DepartsChoix = ({ trip, compact = false }) => {
  const departs = trip.departs || [];
  if (!trip.multi_departs || !departs.length) return null;
  const jour = (trip.duration_days || 1) <= 1;
  return (
    <div data-testid="departs-choix">
      {!compact && (
        <div className="bg-gradient-to-r from-[#5BC5D4] to-[#3BA4B3] text-white rounded-lg p-4 mb-3">
          <p className="font-bold text-base">📅 Choisissez votre date</p>
          <p className="text-xs text-white/85 mt-0.5">{titreDeparts(trip)} — {jour ? 'chaque journée est indépendante' : 'chaque séjour est indépendant'} : inscriptions, places et car séparés. Même programme pour tous les départs.</p>
        </div>
      )}
      <div className={compact ? 'space-y-1.5' : 'space-y-2'}>
        {departs.map((d) => {
          const [txt, cls] = STATUT[d.status] || STATUT.disponible;
          const ouvert = d.status === 'disponible' || d.status === 'moins_10';
          const restantes = d.status === 'moins_10' && d.restantes > 0 ? d.restantes : null;
          return (
            <div key={d.fd_id} className={`rounded-lg border-2 ${ouvert ? 'bg-green-50 border-green-300' : 'bg-gray-50 border-gray-200'} ${compact ? 'px-2.5 py-2' : 'px-4 py-3'}`} data-testid={`depart-${d.fd_id}`}>
              <div className="flex items-center justify-between gap-2">
                <div className="min-w-0">
                  <span className={`font-bold text-gray-800 block ${compact ? 'text-sm' : ''}`}>{d.label}</span>
                  {d.price != null && (
                    <span className="text-xs text-gray-600">{d.price} € par personne{d.transport_price != null ? ` · ${d.transport_price} € avec le car` : ''}</span>
                  )}
                  {restantes != null && (
                    <span className="block text-xs font-bold text-amber-700" data-testid={`depart-restantes-${d.fd_id}`}>Plus que {restantes} place{restantes > 1 ? 's' : ''}</span>
                  )}
                </div>
                <span className={`text-[10px] font-bold px-2 py-0.5 rounded whitespace-nowrap ${cls}`}>{txt}</span>
              </div>
              {!compact && ouvert && (
                <Link to={`/inscription?destination=${encodeURIComponent(d.fd_id)}`} onClick={() => window.scrollTo(0, 0)}
                  className="mt-2 flex items-center justify-center w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 rounded-lg text-sm"
                  data-testid={`depart-inscription-${d.fd_id}`}>
                  S'inscrire pour le {d.label}
                </Link>
              )}
              {!compact && !ouvert && (
                <a href={`https://wa.me/33660416218?text=${encodeURIComponent(`Bonjour, je souhaite être sur la liste d'attente pour "${trip.title}" — départ ${d.label}.`)}`} target="_blank" rel="noreferrer"
                  className="mt-2 flex items-center justify-center w-full bg-orange-500 text-white font-bold py-2 rounded-lg text-sm" data-testid={`depart-attente-${d.fd_id}`}>
                  Liste d'attente (WhatsApp)
                </a>
              )}
            </div>
          );
        })}
      </div>
      {trip.departs_passes > 0 && (
        <p className="text-[11px] text-gray-500 mt-1.5" data-testid="departs-passes">{trip.departs_passes} date{trip.departs_passes > 1 ? 's' : ''} déjà passée{trip.departs_passes > 1 ? 's' : ''}.</p>
      )}
    </div>
  );
};

export default DepartsChoix;
